export class Persona {
    apellido: string;
    nombre: string;
    fechavence: string;
    cuenta: string;
    token:string;
    dni:string;
    documento:string;
    codigo_agencia:String;
    email:String;
    numeroCelular:String;
    montoMaximoMN:number;
    montoMaximoME:number;
    fechapago:string;
    requiereCambioClave:number;
    votacion:number;
    constructor(apellido,nombre,fechavence,cuenta,token,dni,documento,codigo_agencia,email,numeroCelular,montoMaximoMN,montoMaximoME,fechapago,
        requiereCambioClave,votacion=0){
        this.apellido=apellido;
        this.nombre=nombre;
        this.fechavence=fechavence;
        this.cuenta=cuenta;
        this.token=token;
        this.dni=dni;
        this.documento=documento;
        this.codigo_agencia=codigo_agencia;
        this.email=email;
        this.numeroCelular=numeroCelular;
        this.montoMaximoMN=montoMaximoMN;
        this.montoMaximoME=montoMaximoME;
        this.fechapago=fechapago;
        this.requiereCambioClave=requiereCambioClave;
        this.votacion=votacion;

    }
}